export default "__VITE_ASSET__ujsenplN__"